"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sbar = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var SbarAction_1 = require("@/pages/search/actions/sfilter/SbarAction");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var mapStateToProps = function (state) { return state.hfilter; };
var mapDispatchToProps = function (dispatch) { return ({
    onClickInputBox: function () { return dispatch(SbarAction_1.default.onClickInputBox()); },
    onTextChanged: function (text) { return dispatch(SbarAction_1.default.onTextChanged(text)); },
    onClickSave: function () { return dispatch(SbarAction_1.default.onClickSave()); },
    onSaveClick: function () { return dispatch(HfilterAction_1.default.onSaveClick()); },
    onFilterOpenClicked: function () { return dispatch(HfilterAction_1.default.setFilterOpen(true)); },
}); };
exports.sbar = function (props) {
    var hasKeyword = props.keyword ? true : false;
    var hasDistricts = props.districts.filter(function (it) { return it.selected; }).length > 0 ? true : false;
    var hasPriceFilter = props.priceMin !== 0 || props.priceMax !== -1;
    var hasSizeFilter = props.sizeMin !== 0 || props.sizeMax !== -1;
    var hasBedFilter = props.bedsPresets.filter(function (it) { return it.selected; }).length > 0;
    var hasTypeFilter = props.typeOptions.filter(function (it) { return it.selected; }).length > 0;
    var hasAmenitiesFilter = props.amenityOptions.filter(function (it) { return it.selected; }).length > 0;
    var allFilters = [hasKeyword, hasDistricts, hasPriceFilter, hasSizeFilter, hasBedFilter, hasTypeFilter, hasAmenitiesFilter];
    var filterCount = allFilters.filter(function (it) { return it === true; }).length;
    var onTextChanged = function (event) {
        props.onTextChanged(event.currentTarget.value);
    };
    return (React.createElement("div", { className: "c-sbar" },
        React.createElement("div", { className: "c-sbar__search" },
            React.createElement("div", { className: "c-sbar__input-box" },
                React.createElement("div", { className: "c-sbar__input-field" },
                    React.createElement("input", { onClick: props.onClickInputBox, onChange: onTextChanged, value: props.keyword, className: "c-sbar__input", placeholder: props.t.keywordPlaceholder })),
                React.createElement("div", { className: "c-sbar__input-action" },
                    React.createElement("span", { className: "c-form__input-search" }, " ")))),
        React.createElement("div", { className: "c-sbar__actions" },
            React.createElement("button", { onClick: props.onFilterOpenClicked, className: "c-sbar__action js-filter-toggle " + (filterCount > 0 ? 'c-sbar__action--active' : '') },
                React.createElement("span", { className: "c-sbar__action-text" },
                    filterCount ? filterCount + " " : '',
                    props.t.filters),
                " \u00A0",
                React.createElement("span", { className: "fal fa-chevron-down" })),
            React.createElement("button", { onClick: props.onSaveClick, className: "c-sbar__action" }, props.t.save))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.sbar);
